import React, { Component } from "react";
import { Modal, Button, Form, Alert, Cascader, Select, message } from 'antd';
import { getCustomizeInfo, setImproveCustom, setStudentGroupAndProxyOrg, getDownloadSpace } from '@/fetch/api/personal';
import { Local } from '@/utils/local';
import { Decrypt } from '@/utils/encrypt';
import Zmage from 'react-zmage';
import InputContainer from '@/components/CreateFormItem/InputContainer';
import NumberContainer from '@/components/CreateFormItem/NumberContainer';
import SelectContainer from '@/components/CreateFormItem/SelectContainer';
import RadioContainer from '@/components/CreateFormItem/RadioContainer';
import CheckBoxContainer from '@/components/CreateFormItem/CheckBoxContainer';
import CascaderContainer from '@/components/CreateFormItem/CascaderContainer';
import FileContainer from '@/components/CreateFormItem/FileContainer';
import ImgContainer from '@/components/CreateFormItem/ImgContainer';
import DateContainer from '@/components/CreateFormItem/DateContainer';
import DateTimeContainer from '@/components/CreateFormItem/DateTimeContainer';
import DateTimeRangeContainer from '@/components/CreateFormItem/DateTimeRangeContainer';
import './index.less';
const {
  Option
} = Select;
const sceneCodeObj = {
  2: '在购买此课程前',
  3: '在学习此课程前',
  4: '在参加考试前'
};
@Form.create()
export default class CustomInfoModal extends Component {
  constructor(props) {
    super(props); // 0:单行文本;2:数字;3:日期;4:日期时间;5:日期时间范围;6:单选框;7:复选框;8:下拉框;9:级联选项;10:附件上传;11:图片

    this.detailObj = {
      'text': (value, form) => <InputContainer data-inspector-line="33" data-inspector-column="31" data-inspector-relative-path="src\\components\\CustomInfoModal\\index.jsx" data={value} form={form} />,
      'number': (value, form) => <NumberContainer data-inspector-line="34" data-inspector-column="33" data-inspector-relative-path="src\\components\\CustomInfoModal\\index.jsx" data={value} form={form} />,
      'date': (value, form) => <DateContainer data-inspector-line="35" data-inspector-column="31" data-inspector-relative-path="src\\components\\CustomInfoModal\\index.jsx" data={value} form={form} />,
      'dateTime': (value, form) => <DateTimeContainer data-inspector-line="36" data-inspector-column="35" data-inspector-relative-path="src\\components\\CustomInfoModal\\index.jsx" data={value} form={form} />,
      'period': (value, form) => <DateTimeRangeContainer data-inspector-line="37" data-inspector-column="33" data-inspector-relative-path="src\\components\\CustomInfoModal\\index.jsx" data={value} form={form} />,
      'radio': (value, form, list) => <RadioContainer data-inspector-line="38" data-inspector-column="38" data-inspector-relative-path="src\\components\\CustomInfoModal\\index.jsx" data={value} form={form} list={list} handleImg={this.handleImg} />,
      'checkbox': (value, form, list) => <CheckBoxContainer data-inspector-line="39" data-inspector-column="41" data-inspector-relative-path="src\\components\\CustomInfoModal\\index.jsx" data={value} form={form} list={list} handleImg={this.handleImg} />,
      'select': (value, form, list) => <SelectContainer data-inspector-line="40" data-inspector-column="39" data-inspector-relative-path="src\\components\\CustomInfoModal\\index.jsx" data={value} form={form} list={list} handleImg={this.handleImg} />,
      'cascade': (value, form) => <CascaderContainer data-inspector-line="41" data-inspector-column="34" data-inspector-relative-path="src\\components\\CustomInfoModal\\index.jsx" data={value} form={form} type="info" />,
      'annex': (value, form) => <FileContainer data-inspector-line="42" data-inspector-column="32" data-inspector-relative-path="src\\components\\CustomInfoModal\\index.jsx" data={value} form={form} />,
      'image': (value, form) => <ImgContainer.Group data-inspector-line="43" data-inspector-column="32" data-inspector-relative-path="src\\components\\CustomInfoModal\\index.jsx" data={value} form={form} handleImg={this.handleImg} />
    };
    this.state = {
      imgObj: {},
      customList: [],
      // 自定义字段
      ccposList: [],
      // 代理机构字段
      groupList: [],
      // 分组字段
      proxyId: undefined,
      studentGroupValue: []
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.visible !== this.props.visible && this.props.visible) {
      let arr = this.props.customObj.data && this.props.customObj.data.map(value => value.customizeFieldVO) || [];
      arr.forEach((value, index) => {
        value.required = true;
        value.field = value.fieldName;
        value.fieldId = value.id;
        value.fieldOptions = value.dataOptions;
        value.value = value.dataValues && value.dataValues.length && value.dataValues.map(elem => elem.fieldValue).join() || '';
        value.fileImageValues = value.dataValues && value.dataValues.length && value.dataValues || null;
        value.chooseRelList = this.props.customObj.data[index].chooseRelList;
        value.associatedFlag = this.props.customObj.data[index].associatedFlag;
      });
      let groupaArr = [];

      if (this.props.customObj.studentGroup) {
        groupaArr = JSON.parse(JSON.stringify(this.props.customObj.studentGroup).replace(/groupName/g, 'label').replace(/id/g, 'value').replace(/studentGroupRespList/g, 'children'));
      }

      this.setState({
        customList: arr,
        groupList: groupaArr,
        ccposList: this.props.customObj.ccpos ? this.props.customObj.ccpos : [],
        proxyId: this.props.customObj.proxyId ? this.props.customObj.proxyId : undefined,
        studentGroupValue: this.props.customObj.studentGroupValue ? this.props.customObj.studentGroupValue : undefined
      });
    }
  }

  handleTime = string => {
    let d = new Date(string);
    return d.getTime(d);
  };
  handleFormatText = (value, type, code) => {
    // 数据格式化
    if (type === 'date' && code === 'birthday') {
      return value && [this.handleTime(value)] || [];
    }

    if (type === 'date') {
      return value && [value.format('YYYY-MM-DD')] || [];
    }

    if (type === 'dateTime') {
      return value && [value.format('YYYY-MM-DD HH:mm:ss')] || [];
    }

    if (type === 'period') {
      return value && [value[0].format('YYYY-MM-DD HH:mm:ss'), value[1].format('YYYY-MM-DD HH:mm:ss')] || [];
    }

    if (['checkbox', 'cascade', 'image'].includes(type)) {
      return value && value || [];
    }

    return [value || ''];
  };
  handleImgObj = obj => {
    // 去除单个img对象
    let result = Object.keys(obj).reduce((acc, cur) => {
      cur.indexOf('img') === -1 && cur.indexOf('file') === -1 ? acc[cur] = obj[cur] : '';
      return acc;
    }, {});
    return result;
  };
  handleImg = obj => {
    let preObj = this.state.imgObj;
    this.setState({
      imgObj: { ...preObj,
        ...obj
      }
    });
  };
  handleOk = () => {
    this.props.form.validateFieldsAndScroll(async (err, value) => {
      let delSingImgObj = this.handleImgObj(value);
      let paramsValue = Object.assign({}, delSingImgObj, this.state.imgObj); // 自定义字段

      let studentInfos = {}; // 固定字段

      let student = {};

      for (let key in paramsValue) {
        if (key === 'groupId' && paramsValue.groupId) {
          let arr = ['groupOneId', 'groupTwoId', 'groupThreeId', 'groupFourId', 'groupFiveId'];
          paramsValue.groupId.forEach((item, index) => {
            student[arr[index]] = item;
          });
        } else if (key === 'proxyOrgId') {
          student.proxyOrgId = paramsValue.proxyOrgId;
        } else {
          studentInfos[key] = paramsValue[key];
        }
      }

      if (!err) {
        let arr = Object.keys(studentInfos).reduce((acc, cur) => {
          let fieldCode = this.state.customList.find(value => value.fieldId == cur).fieldCode;
          let type = this.state.customList.find(value => value.fieldId == cur).fieldType;
          let obj = {
            fieldId: cur,
            fieldCode
          };

          if (type === 'image') {
            obj.fieldValues = this.handleFormatText(studentInfos[cur], type, fieldCode).map(value => value.resourceId);
            obj.imageInfoList = this.handleFormatText(studentInfos[cur], type, fieldCode);
          } else {
            obj.fieldValues = this.handleFormatText(studentInfos[cur], type, fieldCode);
          }

          acc.push(obj);
          return acc;
        }, []);
        let res = await this.handleSave(arr, student);

        if (res.customFlag === '1' && res.studentFlag === '1') {
          this.props.handleModalCancel && this.props.handleModalCancel();
        }
      }
    });
  };
  handleSave = async (arr, obj) => {
    // 处理保存
    let resObj = {
      customFlag: '1',
      studentFlag: '1'
    };

    if (arr && arr.length) {
      try {
        this.setState({
          dataUploadFlag: false
        });
        let res = await setImproveCustom({
          userId: Local.get('userInfo') && JSON.parse(Decrypt(Local.get('userInfo'))).userId ? Number(JSON.parse(Decrypt(Local.get('userInfo'))).userId) : 0,
          companyId: Local.get('userInfo') ? JSON.parse(Decrypt(Local.get('userInfo'))).companyId : '',
          schoolId: Local.get('schoolId') ? Local.get('schoolId') : 1
        }, arr);
        resObj.customFlag = res.code;
      } catch (e) {}
    }

    if (obj && Object.keys(obj).length) {
      try {
        this.setState({
          dataUploadFlag: false
        });
        let res = await setStudentGroupAndProxyOrg({
          companyId: Local.get('userInfo') ? JSON.parse(Decrypt(Local.get('userInfo'))).companyId : '',
          schoolId: Local.get('schoolId') ? Local.get('schoolId') : 1
        }, {
          userId: Local.get('userInfo') && JSON.parse(Decrypt(Local.get('userInfo'))).userId ? Number(JSON.parse(Decrypt(Local.get('userInfo'))).userId) : 0,
          ...obj
        });
        resObj.studentFlag = res.code;
      } catch (e) {}
    }

    return resObj;
  };
  handleDownloadFile = value => {
    // 下载模板
    const type = value.substring(value.lastIndexOf(".") + 1);
    const imgs = ['JPG', 'jpeg', 'jpg', 'png', 'gif'];

    if (type && imgs.includes(type)) {
      window.open(value);
      return;
    }

    getDownloadSpace({
      "type": "xiazai"
    }).then(res => {
      if (res.code === '1') {
        let baseUrl = window.location.host.indexOf('localhost') != -1 ? 'http://hxkht.dev-s.yunduoketang.cn' : `${window.location.origin}`;
        window.open(`${baseUrl}/student/downLoad?ids=${value}`);
        return;
      }

      message.destroy();
      message.warning(res.message);
    });
  };

  render() {
    const {
      visible,
      handleModalCancel,
      sceneCode
    } = this.props;
    const {
      customList,
      groupList,
      ccposList,
      proxyId,
      studentGroupValue
    } = this.state;
    const {
      getFieldDecorator
    } = this.props.form;
    let showList = customList.filter(value => !value.associatedFlag);
    return <Modal data-inspector-line="237" data-inspector-column="6" data-inspector-relative-path="src\\components\\CustomInfoModal\\index.jsx" title="完善信息" visible={visible} wrapClassName="custom-info-modal" width={643} onOk={this.handleOk} onCancel={() => handleModalCancel && handleModalCancel()}>
        <p data-inspector-line="245" data-inspector-column="8" data-inspector-relative-path="src\\components\\CustomInfoModal\\index.jsx" className="sub-p">{`${sceneCodeObj[sceneCode]}，请先完善以下信息：`}</p>
        <Form data-inspector-line="246" data-inspector-column="8" data-inspector-relative-path="src\\components\\CustomInfoModal\\index.jsx" onSubmit={this.submitInsteadData}>
          {groupList.length && <Form.Item data-inspector-line="249" data-inspector-column="31" data-inspector-relative-path="src\\components\\CustomInfoModal\\index.jsx">
            <div data-inspector-line="250" data-inspector-column="12" data-inspector-relative-path="src\\components\\CustomInfoModal\\index.jsx" className="detail-sel-container">
              <span data-inspector-line="251" data-inspector-column="14" data-inspector-relative-path="src\\components\\CustomInfoModal\\index.jsx" className="detail-sel-title">学员分组<b data-inspector-line="251" data-inspector-column="53" data-inspector-relative-path="src\\components\\CustomInfoModal\\index.jsx">*</b></span>
              {getFieldDecorator('groupId', {
              rules: [{
                required: true,
                message: '请选择学员分组'
              }],
              initialValue: studentGroupValue
            })(<Cascader data-inspector-line="258" data-inspector-column="16" data-inspector-relative-path="src\\components\\CustomInfoModal\\index.jsx" getPopupContainer={triggerNode => triggerNode.parentElement} placeholder='请选择学员分组' options={groupList} />)}
            </div>
          </Form.Item> || null}
          {ccposList.length && <Form.Item data-inspector-line="262" data-inspector-column="31" data-inspector-relative-path="src\\components\\CustomInfoModal\\index.jsx">
            <div data-inspector-line="263" data-inspector-column="12" data-inspector-relative-path="src\\components\\CustomInfoModal\\index.jsx" className="detail-sel-container">
              <span data-inspector-line="264" data-inspector-column="14" data-inspector-relative-path="src\\components\\CustomInfoModal\\index.jsx" className="detail-sel-title">代理机构<b data-inspector-line="264" data-inspector-column="53" data-inspector-relative-path="src\\components\\CustomInfoModal\\index.jsx">*</b></span>
              {getFieldDecorator('proxyOrgId', {
              rules: [{
                required: true,
                message: '请选择代理机构'
              }],
              initialValue: proxyId
            })(<Select data-inspector-line="271" data-inspector-column="16" data-inspector-relative-path="src\\components\\CustomInfoModal\\index.jsx" getPopupContainer={triggerNode => triggerNode.parentElement} placeholder="请选择代理机构">
                  {ccposList.map((value, index) => <Option data-inspector-line="273" data-inspector-column="20" data-inspector-relative-path="src\\components\\CustomInfoModal\\index.jsx" value={value.id} key={index}>{value.name}</Option>)}
                </Select>)}
            </div>
          </Form.Item> || null}
          {showList.map((value, index) => <Form.Item data-inspector-line="280" data-inspector-column="12" data-inspector-relative-path="src\\components\\CustomInfoModal\\index.jsx" key={index}>
              <div data-inspector-line="281" data-inspector-column="14" data-inspector-relative-path="src\\components\\CustomInfoModal\\index.jsx" className="detail-sel-container">
                <span data-inspector-line="282" data-inspector-column="16" data-inspector-relative-path="src\\components\\CustomInfoModal\\index.jsx" className="detail-sel-title">
                  {value.field}
                  {value.required && <b data-inspector-line="284" data-inspector-column="37" data-inspector-relative-path="src\\components\\CustomInfoModal\\index.jsx">*</b> || null}
                  {value.fieldType === 'annex' && <span data-inspector-line="285" data-inspector-column="50" data-inspector-relative-path="src\\components\\CustomInfoModal\\index.jsx" className="other-file">
                    {value.samplePathUrl && <i data-inspector-line="286" data-inspector-column="44" data-inspector-relative-path="src\\components\\CustomInfoModal\\index.jsx" onClick={() => Zmage.browsing({
                  src: value.samplePathUrl
                })}>查看样本</i> || null}
                    {value.stencilPathUrl && <i data-inspector-line="287" data-inspector-column="45" data-inspector-relative-path="src\\components\\CustomInfoModal\\index.jsx" onClick={() => this.handleDownloadFile(value.stencilPathUrl)}>下载模板</i> || null}
                  </span> || null}
                </span>
                <div data-inspector-line="290" data-inspector-column="16" data-inspector-relative-path="src\\components\\CustomInfoModal\\index.jsx" className='detail-tip-wrap'>
                  {value.fieldTip && <span data-inspector-line="291" data-inspector-column="37" data-inspector-relative-path="src\\components\\CustomInfoModal\\index.jsx" className="remind-span">{value.fieldTip}</span> || null}
                  {this.detailObj[value.fieldType](value, this.props.form, customList)}
                </div>
              </div>
            </Form.Item>)}
        </Form>
      </Modal>;
  }

}